import React, { FC, useContext } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import NavWrapper from '../components/wrappers/NavWrapper';
import Users from '../pages/usermanagement';
import { userContext } from '../utils/userContext';

const UserManagementRouter: FC = () => {
    let match = useRouteMatch();
    const { hasModule } = useContext(userContext);

    return (
        <NavWrapper pageName="Brugerhåndtering">
            {!hasModule(match.url) ? <Route component={() => <div>Du har ikke adgang til brugerhåndtering</div>}/> :
                <Switch>
                    <Route exact path={match.url} component={Users}/>
                    <Route> <div>Siden bliv ikke fundet</div></Route>
                </Switch>
            }
        </NavWrapper>
    )
}

export default UserManagementRouter;
